import { useI18n } from '../i18n/index.jsx';

export default function ErrorScreen({ message, onRetry }) {
  const { t } = useI18n();
  const isTelegramError = message?.includes('@WORKIFYPL_bot');

  if (isTelegramError) {
    return (
      <div className="error-screen telegram-redirect">
        <div className="error-icon">💼</div>
        <h2>{t('error_screen.telegram_title')}</h2>
        <p style={{ marginBottom: 8, opacity: 0.8 }}>{t('error_screen.telegram_desc')}</p>
        <a href="https://t.me/WORKIFYPL_bot" className="btn btn-primary"
          style={{ display: 'inline-block', textDecoration: 'none', marginTop: 16, fontSize: 16 }}>
          🤖 {t('error_screen.open_bot')}
        </a>
      </div>
    );
  }

  return (
    <div className="error-screen">
      <div className="error-icon">⚠️</div>
      <h2>{t('error_screen.title')}</h2>
      <p>{message}</p>
      {onRetry && <button className="btn btn-primary" onClick={onRetry}>{t('common.retry')}</button>}
    </div>
  );
}
